export default from './cta-to-fab';



// WEBPACK FOOTER //
// ./app/components/cta-to-fab/index.js